import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import fr from 'vuetify/es5/locale/fr'
import en from 'vuetify/es5/locale/en'
import VueAuth from '@websanova/vue-auth'
import VueAxios from 'vue-axios'
import VueClipboard from 'vue-clipboard2'
import wysiwyg from "vue-wysiwyg";

import 'es6-promise/auto'
import 'vuetify/dist/vuetify.min.css'

import App from './pages/App'
import router from './router'
import auth from './auth'
import axios from 'axios'
import store from './store'
import i18n from './i18n';

import * as Sentry from "@sentry/vue";

import moment from 'moment';
moment.locale(i18n.locale);

Vue.use(Vuetify, {
    iconfont: 'mdi',
    lang: {
        locales: {fr,en},
        current: i18n.locale
    },
    theme: {
        primary: '#00B6E0',
        secondary: '#3EC8E4',
        accent: '#ff5722',
        error: '#f44336',
        warning: '#ffc107',
        info: '#3EC8E4',
        success: '#63CED0'
    }
})

Vue.use(VueClipboard);

// Set Vue globally
window.Vue = Vue
Vue.router = router

Sentry.init({
  Vue,
  dsn: "https://bc06727bee1ef167c5e70a43bff6076b@sentry.mobilethinking.ch/12",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^http:\/\/hlt\.test/, /^https:\/\/staging\.centredugenougeneve\.ch/, /^https:\/\/database\.centredugenougeneve\.ch/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});


// Set Vue authentication
Vue.use(VueAxios, axios)
axios.defaults.baseURL = `${process.env.MIX_APP_URL}/api`
window.appName = `${process.env.MIX_APP_NAME}`
Vue.use(VueAuth, auth)
Vue.use(wysiwyg, {
    hideModules: { "image": true, "table": true, "code": true, "removeFormat": true, "justifyRight":true, "justifyLeft": true, "justifyCenter": true, "headings": true}
})

Vue.filter('yearDate', function(value) {
    return moment(value).format("Y")
})

Vue.filter('shortDate', function(value) {
    return moment(value).format("L")
})

Vue.filter('formatedDate', function(value) {
    console.log('date before : ' + value)
    console.log(moment.locale() + " " + i18n.locale + " " + (moment.locale() === i18n.locale))
    console.log('date after : ' + moment(value).format("L"));
    return moment(value).format("L")
})

const app = new Vue({
    el: '#app',
    store,
    i18n,
    router,
    render: h => h(App)
});

//Hack to get access to axios in the store
store.commit('setAxios', app.$http)
